module.exports = __webpack_public_path__ + "img/afdiag-transparent.58362f06.png";